import { render } from "./RichCompTab.vue?vue&type=template&id=cd9067ca"
import script from "./RichCompTab.vue?vue&type=script&lang=js"
export * from "./RichCompTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__